// Brand-only top tab bar: Dashboard and Profile. Logo left, account avatar and logout right.

import React from 'react';
import { useAuth } from '../../context/AuthContext.jsx';

const BrandTopTabs = ({ onNavigate, activeTab, brandProfile }) => {
  const { user, profile, signOut } = useAuth();
  const avatarUrl = brandProfile?.media?.personAvatarUrl || null;

  const handleSignOut = async () => {
    try {
      await signOut();
      onNavigate('/login', null, { replace: true });
    } catch (err) {
      console.error('Sign out error:', err);
    }
  };

  // Same padding and reserved border space on every tab so nothing shifts when switching.
  const tabBaseClass =
    'relative px-4 py-3 text-sm font-medium transition-colors border-b-2 border-transparent';
  const tabActiveClass = 'text-[#1B9DA2]';
  const tabInactiveClass = 'text-slate-600 hover:text-slate-900';

  const TabButton = ({ isActive, onClick, children }) => (
    <button
      type="button"
      onClick={onClick}
      className={`${tabBaseClass} ${isActive ? tabActiveClass : tabInactiveClass}`}
    >
      {children}
      {/* Underline is out-of-flow so it never affects layout or causes shift */}
      {isActive && (
        <span
          className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#1B9DA2]"
          aria-hidden
        />
      )}
    </button>
  );

  return (
    <header className="bg-white border-b border-slate-200 sticky top-0 z-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-14">
          <div className="flex items-center gap-8">
            <button
              type="button"
              onClick={() => onNavigate('/brand/dashboard', null, { replace: false })}
              className="flex items-center gap-2 text-lg font-bold text-slate-900 hover:text-slate-700"
            >
              <img
                src="/LogoSquare.png"
                alt=""
                className="h-6 w-6 sm:h-7 sm:w-7 rounded flex-shrink-0"
                onError={(e) => { e.target.style.display = 'none'; }}
              />
              <span>InfluenceHub</span>
            </button>
            <nav className="flex gap-0" aria-label="Brand navigation">
              <TabButton
                isActive={activeTab === 'dashboard'}
                onClick={() => onNavigate('/brand/dashboard', null, { replace: false })}
              >
                Dashboard
              </TabButton>
              <TabButton
                isActive={activeTab === 'profile'}
                onClick={() => onNavigate('/brand/profile', null, { replace: false })}
              >
                Profile
              </TabButton>
            </nav>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-slate-100 border border-slate-200 overflow-hidden flex items-center justify-center flex-shrink-0">
              {avatarUrl ? (
                <img src={avatarUrl} alt="" className="w-full h-full object-cover" />
              ) : (
                <span className="text-slate-400 text-sm font-medium">
                  {(profile?.displayName || user?.email || '?').charAt(0).toUpperCase()}
                </span>
              )}
            </div>
            <button
              type="button"
              onClick={handleSignOut}
              className="text-sm text-slate-500 hover:text-slate-700 px-2 py-1.5 rounded-md hover:bg-slate-100"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default BrandTopTabs;
